import { render, staticRenderFns } from "./loginTam.vue?vue&type=template&id=75716721&scoped=true&"
import script from "./loginTam.vue?vue&type=script&lang=js&"
export * from "./loginTam.vue?vue&type=script&lang=js&"
import style0 from "./loginTam.vue?vue&type=style&index=0&id=75716721&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75716721",
  null
  
)

export default component.exports